import { render, staticRenderFns } from "./TextEditor.html?vue&type=template&id=6bab306e&external"
import script from "./TextEditor.ts?vue&type=script&lang=ts&external"
export * from "./TextEditor.ts?vue&type=script&lang=ts&external"
import style0 from "./TextEditor.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports